import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {practiceRoutesPath} from './path';

const CoursePage = Loadable(
  lazy(() =>
    import('@src/v2/pages/Course' /* webpackChunkName: "course-page" */).then(
      module => ({default: module.CoursePage}),
    ),
  ),
);
const CourseGoalsPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/CourseGoals' /* webpackChunkName: "course-goals-page" */
    ).then(module => ({default: module.CourseGoalsPage})),
  ),
);
const CRUProgramPage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/CRUProgram' /* webpackChunkName: "cru-program-page" */
      ),
  ),
);
const PracticePublicPage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/PracticePublic' /* webpackChunkName: "practice-public-page" */
      ),
  ),
);
const PracticePage = Loadable(
  lazy(
    () => import('@src/pages/Practice' /* webpackChunkName: "practice-page" */),
  ),
);
const ProgramPublicPage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/ProgramPublic' /* webpackChunkName: "program-public-page" */
      ),
  ),
);
const ProgramPage = Loadable(
  lazy(
    () => import('@src/pages/Program' /* webpackChunkName: "program-page" */),
  ),
);

export const practiceRoutes = [
  {
    element: <PracticePage />,
    path: practiceRoutesPath.coachPractice.$path(),
    publicElement: <PracticePublicPage />,
  },
  {
    element: <ProgramPage />,
    path: practiceRoutesPath.coachPractice.program.$path(),
    publicElement: <ProgramPublicPage />,
  },
  {
    element: <CoursePage />,
    path: practiceRoutesPath.coachPractice.program.course.$path(),
  },
  {
    element: <CourseGoalsPage />,
    path: practiceRoutesPath.coachPractice.program.course.goals.$path(),
  },
  {
    element: <CRUProgramPage key="create-program" />,
    forCoach: true,
    path: practiceRoutesPath.createProgram.$path(),
  },
  {
    element: <CRUProgramPage key="edit-program" />,
    forCoach: true,
    path: practiceRoutesPath.editProgram.$path(),
  },
  {
    element: <CRUProgramPage key="clone-program" />,
    forCoach: true,
    path: practiceRoutesPath.cloneProgram.$path(),
  },
] satisfies RouteConfig[];
